module.exports = __webpack_public_path__ + "static/img/MR.1073ae80.png";